import { KeycloakConstants } from "../types/auth";

export const KEYCLOAK: KeycloakConstants = {
  URL: process.env.GUAC_KEYCLOAK_URL,
  REALM: process.env.GUAC_KEYCLOAK_REALM,
  CLIENT_ID: process.env.GUAC_KEYCLOAK_CLIENT_ID,
  ON_LOAD: "check-sso",
  TOKEN_EXPIRATION_TIME: 70, // s
  DEFAULT_UPDATE_INTERVAL: 6000, //ms
};
